// État de l'écran affiché, poussé aux bulles d'experts (titre, accroche, KPIs visibles, filtres).
const state = { path: '', titre: '', accroche: '', kpis: [], filtres: null, item: null };
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn({ ...state }));

export const setScreenState = (patch) => {
  const path = window.location.pathname + window.location.search;
  if (state.path !== path) { state.titre = ''; state.accroche = ''; state.kpis = []; state.filtres = null; state.item = null; state.path = path; }
  Object.assign(state, patch);
  emit();
};

export const setScreenKpis = (kpis) => setScreenState({ kpis: (kpis || []).filter((k) => k && k.label && k.value != null).slice(0, 24).map((k) => ({ label: String(k.label).slice(0, 60), value: String(k.value).slice(0, 40) })) });

export const getScreenState = () => {
  const path = window.location.pathname + window.location.search;
  if (state.path !== path) return { path };
  return { ...state };
};

export const subscribeScreenState = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
